<app-settings-base
  title="{{'businessSupportSettings.title' | translate}}"
  description="{{'businessSupportSettings.text' | translate}}"
  details="{{'businessSupportSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/business-support">
</app-settings-base>
